import React, { Component } from "react";
import Axios from "axios";
import { configuration } from "../../appConfig";
import { connect } from "react-redux";
import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

// Axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

class CustomerInfoTableSwiss extends Component {
  state = {
    data: [],
    orderNumber: "",
    words: {},
    lang: "gb",
    kilometerStand:'',
    comment:'',
    manufacturer:'',
    regNo:'',
    model:'',
    color:'',
    Name:'',
    estimateId:'',
    jsondata:[],
    Authorized : null
  };
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      this.setState({
        words: res.data,
        lang: localStorage.getItem("lang"),
      });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;

    return words[word] ? words[word][lang] : word;
  };
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.lang !== prevState.lang) {
      return { lang: nextProps.lang };
    } else if (nextProps.Authorized !== prevState.Authorized) {
      return {  Authorized : nextProps.Authorized };
    }else return null;
  }
  componentDidMount() {
    // this.customerInfo();
    this.getLang();
    // this.getJsonData();
    this.updateFinalData();
  }

  updateFinalData() {
    // const { manufacturerJSON, manufacturerCustomerInfo} = this.state;
    // if (manufacturerJSON.length) {
    //   this.setState({
    //     manufacturerFinal:manufacturerJSON,
    //   })
    // } else {
    //   this.setState({
    //     manufacturerFinal:manufacturerCustomerInfo,
    //   })
    // }

    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
       this.setState({
         jsondata:r.data,
         manufacturer : r.data.Make || '',
         regNo : r.data.RegNo || '',
         actualVIN: r.data.ActualVin || '',
         model :r.data.Model || '',
         color :r.data.Color || '',
         Name : r.data.PartnerName || '',
         comment : r.data.Comments || '',
         estimateId : r.data.OrderNo || '',
       })
      }
    }).then( async ()=>{
      if (partnerId) {
        const res = await Axios.get(
          configuration.getCustomerInfo +
            "?partnerId=" +
            partnerId +
            "&vin=" +
            vin
        );
        if (res.data.length) {
          this.setState({
            data: res.data[0],
            kilometerStand:res.data[0].kilometerStand || "-",
            estimateId: (!this.state.estimateId ? ( res.data[0].orderid || '-') : this.state.estimateId),
            manufacturer: (!this.state.manufacturer ? ( res.data[0].manufacturer || '-') : this.state.manufacturer),
            regNo: (!this.state.regNo ? ( res.data[0].regNo || '-') : this.state.regNo),
            model: (!this.state.model ? ( res.data[0].model || '-') : this.state.model),
            color: (!this.state.color ? ( res.data[0].color || '-') : this.state.color),
            Name: (!this.state.Name ? ( res.data[0].Name || '-') : this.state.Name),
            comment: (!this.state.comment ? ( res.data[0].comment || '-') : this.state.comment),
          });
          localStorage.setItem("InsurenceName", res.data[0].InsurenceName);
        } 
      } 
    }).catch((err)=>console.log(err))
  }
  
  customerInfo = async () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    if (partnerId) {
      const res = await Axios.get(
        configuration.getCustomerInfo +
          "?partnerId=" +
          partnerId +
          "&vin=" +
          vin
      );
      if (res.data.length) {
        this.setState({
          data: res.data[0],
          orderNumber: res.data[0].orderid || "",
          kilometerStand:res.data[0].kilometerStand || "",
          comment:res.data[0].comment || ""
        });
        localStorage.setItem("InsurenceName", res.data[0].InsurenceName);
      } else {
        // let clr = {
        //   "Name":  "",
        //   "color":  "",
        //   "comment":  "",
        //   "kilometerStand":"",
        //   "customerCity":  "",
        //   "customerNumber": "",
        //   "emailAddress":  "",
        //   "manufacturer": "",
        //   "model":  "",
        //   "partnerId": partnerId,
        //   "partnerId":  "",
        //   "postalCode": "",
        //   "regNo":  "",
        //   "vinNumber": vin,
        //   "Address":"",
        //   "estimateId":"",
        // };
        // this.setState({ data: clr });
      }
    } else {
    }
  };

  getJsonData = () => {
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");

    Axios.get(
      `${configuration.getData}?vin=${vin}&partnerId=${partnerId}`
    ).then((r) => {
      if (r.data) {
       this.setState({
         jsondata:r.data,
         Authorized : r.data.Authorized
       })
      }
    });
  }

  handleChange = (e) =>{
    const {name, value} = e.target;
    this.setState({
      [name]:value,
    })
  }
  
  handleSave = ()=>{
    // make api req here
    const { data,jsondata } = this.state;
    const partnerId = localStorage.getItem("partnerId");
    const vin = localStorage.getItem("selectedFile");
    const url = configuration.PostCustomerInfo + 
    "?partnerId=" +
    partnerId +
    "&vin=" +
    vin.split("_")[0];
    const qrUrl = configuration.updateQRInfo + "?partnerId=" + partnerId + "&vin=" + vin.split("_")[0];

    const updatedData = {
      "Name": this.state.Name,
      "color": this.state.color,
      "comment": this.state.comment,
      "kilometerStand":this.state.kilometerStand,
      "customerCity": data.customerCity || "",
      "customerNumber": data.customerNumber || "",
      // "emailAddress": data.emailAddress || "",
      "manufacturer": this.state.manufacturer,
      "model": this.state.model,
      "partnerId":partnerId,
      "postalCode": data.postalCode || "",
      "regNo": this.state.regNo,
      "vinNumber": vin,
      // "street":"",
      "estimateId":this.state.estimateId,
      // "Inv1" :this.state.Inv1

    }
    let qrPayload = {
      ...updatedData,
      InsurenceName: this.state.InsurenceName || "",
    };
    Axios.post(qrUrl, qrPayload)
      .then((res) => {
        if (res.data) {
          Axios.post(url, updatedData).then((res) => {
            this.state.jsondata.PartnerName = this.state.Name;
            this.state.jsondata.Color = this.state.color;
            this.state.jsondata.Comments = this.state.comment;
            this.state.jsondata.kilometerStand = this.state.kilometerStand;
            this.state.jsondata.Make = this.state.manufacturer;
            this.state.jsondata.Model = this.state.model;
            this.state.jsondata.RegNo = this.state.regNo;
            this.state.jsondata.OrderNo = this.state.estimateId;
            this.state.jsondata.ActualVin = this.state.actualVIN;
            this.setState({ jsondata: this.state.jsondata });
    
            const jsonurl =
              configuration.PostEditorChanges +
              `?partnerId=${localStorage.getItem(
                "partnerId"
              )}&vin=${localStorage.getItem("selectedFile")}&TabViewUpdated=${!jsondata.TabViewUpdated}`;
    
            Axios.post(jsonurl, this.state.jsondata).then((res) => {
              Toast.fire({
                type: "success",
                title: "Data saved successfully",
              });
            });
          });
        }
      })
      .catch((err) =>
        Toast.fire({
          type: "error",
          title: "Something went wrong",
        })
      );    
  }
  render() {
    const { data, jsondata, Authorized } = this.state;
    return (
      <div className="container p-0">
        <div className="d-list-middle row p-0">
          <div className="main-heading-general col-12 p-0">
            <h3>
              {this.lang("General")}<span> {this.lang("Information")}</span>{" "}
            </h3>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 customer-info-main p-0">
          <div className="row p-0 first-row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-bold one">
                <p className="m-0 p-0">{this.lang("Estimate Id")}</p>
                </div>
              </div>
              {/* <div className="col-lg-1 col-md-1 col-sm-12"></div> */}
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-light one">
              {
                this.props.viewType === 'TabView' ? 
                <input className="m-0 p-0 font-weight-bold"
                  value={this.state.estimateId}
                  disabled
                  onChange={this.handleChange}
                  // onBlur={this.handleBlur}
                  name='estimateId'
                  style={{background:'none', outline:'none',border:'none',width:"100%" }} 
                /> :
                <p className="m-0 p-0 font-weight-bold"> 
                  {this.state.estimateId}
                </p> 
              }
              </div>

              {/* <p className="m-0 p-0">{ localStorage.getItem("selectedFile").split("_")[0] ||  "-"}</p> */}
              </div>
            </div>
            <div className="row p-0 new-row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
              <div className="text-heading-bold one">
              <p className="m-0 p-0">{this.lang("Reg Number")}</p>
              </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">

              <div className="text-heading-light one">
              {
                this.props.viewType === 'TabView' ? 
                <input className="m-0 p-0 font-weight-bold"
                  value={this.state.regNo}
                  disabled={!this.props.viewType || Authorized}
                  onChange={this.handleChange}
                  // onBlur={this.handleBlur}
                  name='regNo'
                  style={{background:'none', outline:'none',border:'none',width:"100%" }} 
                /> :
                <p className="m-0 p-0 font-weight-bold"> 
                  {this.state.regNo}
                </p> 
              }
              </div>
              {/* <p className="m-0 p-0">{data.regNo || jsondata.RegNo || "-"}</p> */}
              </div>
            </div>
            
            <div className="row p-0 new-row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-bold one">
                <p className="m-0 p-0">{this.lang("VIN")}</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-light one">
                  {
                    this.props.viewType === 'TabView' ? 
                        <input className="m-0 p-0 font-weight-bold"
                        value={ this.state.actualVIN}
                        disabled={!this.props.viewType || Authorized}
                        onChange={this.handleChange}
                        name='actualVIN'
                        style={{background:'none', outline:'none',border:'none',width:"100%" }} 
                        /> 
                    :
                        <p className="m-0 p-0 font-weight-bold">{this.state.actualVIN || localStorage.getItem("selectedFile").split("_")[0]}</p>
                    }
                 </div>
              </div>
            </div>

            <div className="row p-0 new-row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-bold one">
                  <p className="m-0 p-0">{this.lang("Kilometer Stand")}</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-light one">
              {
                this.props.viewType === 'TabView' ? 
                <input className="m-0 p-0 font-weight-bold"
                  value={this.state.kilometerStand}
                  disabled={!this.props.viewType || Authorized}
                  onChange={this.handleChange}
                  // onBlur={this.handleBlur}
                  name='kilometerStand'
                  style={{background:'none', outline:'none',border:'none',width:"100%" }} 
                /> :
                <p className="m-0 p-0 font-weight-bold"> 
                  {data.kilometerStand || " - "}
                </p> 
              }


               
              {/* <p className="m-0 p-0 font-weight-bold">{localStorage.getItem("selectedFile").split("_")[0]}</p> */}
              </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 customer-info-main p-0">
          <div className="row p-0 first-row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-bold one">
                  <p className="m-0 p-0 ">{this.lang("Make")}</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-light one">

              {
                this.props.viewType === 'TabView' ? 
                <input className="m-0 p-0 font-weight-bold"
                  value={this.state.manufacturer}
                  disabled={!this.props.viewType || Authorized}
                  onChange={this.handleChange}
                  // onBlur={this.handleBlur}
                  name='manufacturer'
                  style={{background:'none', outline:'none',border:'none',width:"100%" }} 
                /> :
                <p className="m-0 p-0 font-weight-bold"> 
                  {this.state.manufacturer}
                </p> 
              }

              {/* <p className="m-0 p-0">{data.manufacturer || jsondata.Make || "-"}</p> */}
              </div>
              </div>
            </div>
            <div className="row p-0 new-row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-bold one">
              <p className="m-0 p-0">{this.lang("Model")}</p>
              </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-light one">

              {
                this.props.viewType === 'TabView' ? 
                <input className="m-0 p-0 font-weight-bold"
                  value={this.state.model}
                  disabled={!this.props.viewType || Authorized}
                  onChange={this.handleChange}
                  // onBlur={this.handleBlur}
                  name='model'
                  style={{background:'none', outline:'none',border:'none',width:"100%" }} 
                /> :
                <p className="m-0 p-0 font-weight-bold"> 
                  {this.state.model}
                </p> 
              }

              {/* <p className="m-0 p-0">{data.model ||jsondata.Model || "-"}</p> */}
              </div>
              </div>
            </div>
            <div className="row new-row p-0">
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-bold one">
              <p className="m-0 p-0 ">{this.lang("Color")}</p>
              </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-light one">


              {
                this.props.viewType === 'TabView' ? 
                <input className="m-0 p-0 font-weight-bold"
                  value={this.state.color}
                  disabled={!this.props.viewType || Authorized}
                  onChange={this.handleChange}
                  // onBlur={this.handleBlur}
                  name='color'
                  style={{background:'none', outline:'none',border:'none',width:"100%" }} 
                /> :
                <p className="m-0 p-0 font-weight-bold"> 
                  {this.state.color}
                </p> 
              }

              
                {/* <p className="m-0 p-0">{this.lang(data.color) || this.lang(jsondata.Color) || "-"}</p> */}
              </div>
              </div>
            </div>

            <div className="row new-row p-0">
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-bold one">
                  <p className="m-0 p-0 "> {this.lang("Scanner")} </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-6 p-0">
                <div className="text-heading-light one">
                <p className="m-0 p-0">{jsondata.ScannerNo} &nbsp;
                </p>
              </div>
              </div>
            </div>
            
          </div>
        </div>
        {/* <div className="row p-0 mt-3">

        <div className="col-lg-6 col-md-6 col-sm-12 customer-info-main p-0 m-0 text-heading-bold one">
          <div className="row new-row p-0">
            <div className="col-lg-5 col-md-12 col-sm-12 text-heading-bold one">
            Customer Name
            </div>
            <div className="col-lg-1 col-md-12 col-sm-12"></div>
            <div className="col-lg-6 col-md-12 col-sm-12 text-heading-light one">
              -
            </div>
          </div>
        </div>

        <div className="col-lg-6 col-md-6 col-sm-12 customer-info-main p-0 m-0 text-heading-bold one">
          <div className="row new-row p-0">
            <div className="col-lg-1 col-md-12 col-sm-12"></div>
            <div className="col-lg-5 col-md-12 col-sm-12 text-heading-bold one">
            Customers: first name
            </div>
            <div className="col-lg-1 col-md-12 col-sm-12"></div>
            <div className="col-lg-5 col-md-12 col-sm-12 text-heading-light one">
              -
            </div>
          </div>
        </div>

        </div> */}
        <div className="row p-0 mt-1">
          <div className="col-lg-3 col-md-3 col-sm-6 col-3 customer-info-main p-0 m-0">
            <div className="row p-0 m-0">
              <div className="col-12 p-0">
              <div className="text-heading-bold one">
              <p className="m-0 p-0">{this.lang("Customer Name")}</p>
              </div>
              </div>
            </div>
          </div>
          <div className="col-lg-9 col-md-9 col-sm-6 col-9 customer-info-main p-0 m-0">
            <div className="row p-0 m-0">
              <div className="col-12 p-0">
              <div className="text-heading-light one">
              {
                this.props.viewType === 'TabView' ? 
                <input className="m-0 p-0 font-weight-bold"
                  value={this.state.Name}
                  disabled={!this.props.viewType || Authorized}
                  onChange={this.handleChange}
                  // onBlur={this.handleBlur}
                  name='Name'
                  style={{background:'none', outline:'none',border:'none',width:"100%" }} 
                /> :
                <p className="m-0 p-0 font-weight-bold"> 
                  {this.state.Name}
                </p> 
              }



              {/* <p className="m-0 p-0">{data.Name || jsondata.PartnerName || "-"}</p> */}
              </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row p-0 mt-1">
          <div className="col-lg-3 col-md-6 col-sm-12 col-3 customer-info-main p-0 m-0">
            <div className="row p-0 m-0">
              <div className="col-12 p-0">
              <div className="text-heading-bold one">
              <p className="m-0 p-0">{this.lang("Notes")}</p>
              </div>
              </div>
            </div>
          </div>
          <div className="col-lg-9 col-md-6 col-sm-12 col-9 customer-info-main p-0 m-0">
            <div className="row new-row p-0 m-0">
              <div className="col-12 p-0">
              <div className="text-heading-light one">
              {
                this.props.viewType === 'TabView' ? 
                <input className="m-0 p-0 font-weight-bold"
                  value={this.state.comment }
                  title={this.state.comment}
                  disabled={!this.props.viewType || Authorized}
                  onChange={this.handleChange}
                  // onBlur={this.handleBlur}
                  name="comment"
                  style={{ background:'none', outline:'none',border:'none', width:"100%" }} 
                /> :
                <p className="m-0 p-0 font-weight-bold" title={ this.state.comment } style={{textTransform:'none'}}> 
                {this.state.jsondata.ScannerLocation ? (this.state.comment && this.state.comment !== '-') ? `${this.state.comment}, Location: ${this.state.jsondata.ScannerLocation}` : `Location: ${this.state.jsondata.ScannerLocation}` : this.state.comment ? this.state.comment : '-'}
                </p> 
              }
              
{/*               
              <p className="m-0 p-0"> {" "}
                {data.comment &&
                data.comment != "undefined" &&
                data.comment != "Undefined"
                  ? data.comment
                  : " - "}</p> */}
              </div>
              </div>
            </div>
          </div>
          {
              this.props.viewType === 'TabView' && 
                <div className="row px-0">
                  <div className="col-12 text-right px-0">
                  
                    <button
                      style={{
                        // padding:'5px',
                        backgroundColor:'#F20000',
                        padding: "5px 10px",
                        color : 'white',
                        border: "none",
                        borderRadius: "5px",
                        fontSize: "16px",
                      
                      }}
                      onClick={this.handleSave}
                      disabled={Authorized}
                    >
                      {this.lang("Update Info")}
                    </button>
                
                  </div>
                </div>
          }
        </div>
      </div>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
  };
};
export default connect(mapStateToProps)(CustomerInfoTableSwiss);
